import { Badge } from '@capawesome/capacitor-badge'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { useApiClient } from '@/api'
import type { Counter } from '@/generated/api'

import { useAuthStore } from '../auth/store'

export const useCounterStore = defineStore('counter', () => {
  const apiClient = useApiClient()
  const counter = ref<Counter | null>(null)
  const isBadgeSupported = ref(false)
  const auth = useAuthStore()

  async function getCounter() {
    if (!auth.user) {
      return
    }
    counter.value = await apiClient.counter.counterRetrieve()
    if (isBadgeSupported.value) {
      await Badge.set({
        count: counter.value?.messages || 0,
      })
    }
  }

  return {
    counter,
    getCounter,
    isBadgeSupported,
  }
})
